import { jsx as o } from "react/jsx-runtime";
import { useChatbotContext as a } from "../../hooks/useChatbotContext.js";
function s(t) {
  const { cn: e } = a();
  return /* @__PURE__ */ o(
    "li",
    {
      ...t,
      className: e(
        "mr-5 flex animate-fadeIn flex-row items-start @notMobile:mr-10",
        t.className
      )
    }
  );
}
export {
  s as BotMessageLayout
};
